module.exports = __webpack_public_path__ + "static/media/AugustaMargaretRiverTimes-devicecomp-min@2x.2a5fc496.png";